(function () {
	var PAGE_API_NAME = 'promotion-was-shown';
	var STORAGE_KEY = 'ablyft_promo_shown';

	var PROMO = '.header-promotion-block';
	var DESKTOP_ITEM = '.site-nav__item.site-nav--has-dropdown';
	var DESKTOP_OPEN = 'is-focused';
	var DRAWER = '#NavDrawer';
	var DRAWER_OPEN = 'drawer--is-open';
	var MOBILE_PANEL = '.collapsible-content';
	var MOBILE_OPEN = 'is-open';

	var activated = false;
	var drawer = null;
	var mobilePanels = [];
	var observer = null;


	function wasShown() {
		try {
			return sessionStorage.getItem(STORAGE_KEY) === '1';
		} catch (e) {
			return false;
		}
	}

	function rememberShown() {
		try {
			sessionStorage.setItem(STORAGE_KEY, '1');
		} catch (e) {}
	}

	function activatePage() {
		window.ablyft = window.ablyft || [];
		window.ablyft.push({ eventType: 'activatePage', pageApiName: PAGE_API_NAME });
	}

	function activate() {
		if (activated) return;
		activated = true;
		if (observer) observer.disconnect();
		rememberShown();
		activatePage();
	}

	function drawerIsOpen() {
		return !!drawer && drawer.classList.contains(DRAWER_OPEN);
	}

	function anyMobilePanelOpen() {
		return mobilePanels.some(function (panel) {
			return panel.classList.contains(MOBILE_OPEN);
		});
	}

	function hasPromo(el) {
		return !!el.querySelector(PROMO);
	}

	function watch(el) {
		observer.observe(el, { attributes: true, attributeFilter: ['class'] });
	}

	function init() {
		if (activated) return;

		if (!observer) {
			observer = new MutationObserver(function (mutations) {
				for (var i = 0; i < mutations.length && !activated; i++) {
					var el = mutations[i].target;
					if (el === drawer) {
						if (drawerIsOpen() && anyMobilePanelOpen()) activate();
					} else if (el.classList.contains(DESKTOP_OPEN) || (drawerIsOpen() && el.classList.contains(MOBILE_OPEN))) {
						activate();
					}
				}
			});
		}

		drawer = document.querySelector(DRAWER);
		mobilePanels = drawer ? Array.prototype.filter.call(drawer.querySelectorAll(MOBILE_PANEL), hasPromo) : [];

		var desktopItems = Array.prototype.filter.call(document.querySelectorAll(DESKTOP_ITEM), hasPromo);
		if (!desktopItems.length && !mobilePanels.length) return;

		desktopItems.forEach(watch);
		mobilePanels.forEach(watch);
		if (drawer) watch(drawer);
	}

	if (wasShown()) {
		activated = true;
		activatePage();
		return;
	}

	init();
	document.addEventListener('shopify:section:load', init);
})();
